module.exports = __webpack_public_path__ + "img/2.3d0594da.png";